<ion-header>
    <ion-toolbar>
        <ion-title>Instaliraj aplikaciju</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
    <div class="steps">
        <div class="step">
            <div class="icon">···</div>
            <p>Pritisni <strong>Više</strong> ako nema ikone dijeljenja</p>
        </div>

        <div class="step">
            <div class="icon">
                <ion-icon name="share-outline"></ion-icon>
            </div>
            <p>Pritisni <strong>Dijeli</strong> u navigacijskoj traci</p>
        </div>

        <div class="step">
            <div class="icon">
                <div class="icon">+</div>
            </div>
            <p>Skrolaj do i pritisni <strong>"Dodaj na početni zaslon"</strong></p>
        </div>
    </div>

    <ion-button color="primary" expand="block" (click)="close()">Razumijem</ion-button>
</ion-content>